import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-response-dialog',
  templateUrl: './response-dialog.component.html',
  styleUrls: ['./response-dialog.component.scss'],
})
export class ResponseDialogComponent implements OnInit {
  public icon: string;
  public text: string;
  public textAddParticipant: string[];
  public title: string;
  public fName: string;
  public fIndex: any;
  public previousUrl: any;
  public buttonCancel: boolean;
  public buttonClose: boolean;
  hasButtonAccept: boolean;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<ResponseDialogComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.text = data?.text;
    this.icon = data?.icon;
    if (data.textAddParticipant && data.textAddParticipant?.length !== 0) {
      this.text = `${data.textAddParticipant[0]}\n\n${data.textAddParticipant[1]}`;
    }

    if (data?.title) this.title = data.title;
    else {
      this.title =
        data?.icon === 'icon-ic_circle_check'
          ? this.text === this.translateService.instant('dialog.whitelist.response.success')
            ? 'whitelistDialogResponse.title.success'
            : 'dialog.response.titleSuccess'
          : 'dialog.response.titleError';
    }
    this.buttonCancel = data?.buttonCancel;
    this.hasButtonAccept =
      Object.keys(data).findIndex((key) => key === 'hasButtonAccept') >= 0 ? data.hasButtonAccept : true;
    this.buttonClose = data?.buttonClose;
  }

  ngOnInit(): void {}

  accept(): void {
    this.dialogRef.close(true);

    if (
      this.text !== this.translateService.instant('dialog.whitelist.response.success').toUpperCase() &&
      this.text !== this.translateService.instant('dialog.updateProfiles.response.success').toUpperCase() &&
      this.text !== this.translateService.instant('dialog.userProfiles.response.success').toUpperCase() &&
      this.text !== this.translateService.instant('deleteProfile.infoDialog.success').toUpperCase() &&
      this.text !== this.translateService.instant('dialog.manageAttributions.success').toUpperCase() &&
      this.text !== this.translateService.instant('brandMaintenance.dialog.success').toUpperCase() &&
      this.text !== this.translateService.instant('brandMaintenance.dialog.error').toUpperCase() &&
      this.text !== this.translateService.instant('brandMaintenance.dialog.errorDuplicate').toUpperCase() &&
      this.text !== this.translateService.instant('whitelistDialogResponse.success').toUpperCase() &&
      this.text !== this.translateService.instant('whitelistDialogResponse.error').toUpperCase() &&
      (this.title === 'dialog.response.titleSuccess' || this.title === 'dialog.title.IC')
    ) {
      if (this.data.noRedirect) {
        //PROBAR BIEN ESTO
        this.dialogRef.close();
      } else {
        this.router.navigate(['/requests/panel'], { replaceUrl: true });
      }
    }
    // ESPSCFWMTS-7415 Controlar navegación a detalle de solicitud
    if (this.text == this.translateService.instant('policy.privacity.formalized')) {
      this.goBack();
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  // ESPSCFWMTS-7415 Controlar navegación a detalle de solicitud
  goBack() {
    this.previousUrl = JSON.parse(localStorage.getItem('previusRoute'));
    this.router.navigate([this.previousUrl.url, { keepFilter: true }]);
  }
}
